// extracted by mini-css-extract-plugin
export default {"inner":"style_inner__uq-cD"};